import { Text, View } from '@react-pdf/renderer';
import styles from '../common/styles';
import { useTranslation } from 'react-i18next';
import { Likelihood } from '@components/Activity/types/Likelihood';

type Props = {
  sourcePresentLikelihood: Likelihood;
  ignitionLikelihood: Likelihood;
};

function RiskAssessmentIgnitionSourceTable({ sourcePresentLikelihood, ignitionLikelihood }: Props) {
  const { t } = useTranslation();
  const baseMessage = 'risk.assessment.details.page.risk.details.container.table.row';

  const rows = Object.keys(sourcePresentLikelihood);
  const valueWidth = 150;
  const headingWidth = 200;
  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        <View style={[{ width: headingWidth }, styles.bold]}>
          <Text>
            {t('risk.assessment.details.page.risk.details.container.table.header.ignition.source')}
          </Text>
        </View>
        <View style={[{ width: valueWidth }, styles.bold]}>
          <Text>
            {t('risk.assessment.details.page.risk.details.container.table.header.column1')}
          </Text>
        </View>
        <View style={[{ width: valueWidth }, styles.bold]}>
          <Text>
            {t('risk.assessment.details.page.risk.details.container.table.header.column2')}
          </Text>
        </View>
      </View>
      {rows.map((row, index) => {
        if (row.match(/.*other.*/)) {
          return <></>;
        }
        return (
          <View style={styles.tableRow} key={index}>
            <View style={[{ width: headingWidth }, styles.bold]}>
              <Text>{t(`${baseMessage}.${row}`)}</Text>
            </View>
            <View style={[{ width: valueWidth }, styles.mediumGray]}>
              <Text>{t(sourcePresentLikelihood[row] as string)}</Text>
            </View>
            <View style={[{ width: valueWidth }, styles.mediumGray]}>
              <Text>{t(ignitionLikelihood[row] as string)}</Text>
            </View>
          </View>
        );
      })}
      {sourcePresentLikelihood.otherTxt && (
        <View style={styles.tableRow}>
          <View style={[{ width: headingWidth }, styles.bold]}>
            <Text>{sourcePresentLikelihood.otherTxt}</Text>
          </View>
          <View style={[{ width: valueWidth }, styles.mediumGray]}>
            <Text>{t(sourcePresentLikelihood.otherPresent as string)}</Text>{' '}
          </View>
          <View style={[{ width: valueWidth }, styles.mediumGray]}>
            <Text>{t(ignitionLikelihood.otherIgnition as string)}</Text>
          </View>
        </View>
      )}
    </View>
  );
}

export default RiskAssessmentIgnitionSourceTable;
